import { Button } from 'antd'
import { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import { RNHome, RNProfile } from '../helpers/routeNames'

const Welcome: FC = () => {
	const navigate = useNavigate()

	return (
		<main className="welcomeMain">
			<img src="/logo.png" alt="Logo" className="welcomeImg" />
			<h1 className="welcomeHeader">Добро пожаловать</h1>

			<div style={{ display: 'flex', gap: 10 }}>
				<Button
					type="primary"
					size="large"
					onClick={() => navigate(RNHome)}>
					Главная страница
				</Button>

				<Button
					type="primary"
					size="large"
					onClick={() => navigate(RNProfile)}>
					Профиль
				</Button>
			</div>
		</main>
	)
}
export default Welcome
